import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import DatatableTables from "../../globals/core/Tables/DatatableTables";
import { CurrentCommunity } from "./CurrentCommunity";
import avatar from "./../../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { showLoader } from "../../store/actions/mainActions";
import { CommunitiesService } from "../../globals/services/communities.service";
import { UsersService } from "../../globals/services/users.service";
import { CommunityForm } from "./CommunityForm";
import {
  resetModal,
  setModalChild,
  setModalState,
} from "../../store/actions/modalActions";

export const Communities = (props) => {
  const [communities, setCommunities] = useState([]);
  const [users, setUsers] = useState([]);
  // const [posts, setPosts] = useState([]);
  const [currentCommunity, setCurrentCommunity] = useState(null);
  const dispatch = useDispatch();
  const [reload, setReload] = useState({});
  const [mounted, setMounted] = useState(true);

  const openFormEdit = (c, action) => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(<CommunityForm action={action} currentCommunity={c} />)
    );
  };

  const update = async (c) => {
    try {
      const communitiesService = CommunitiesService();
      dispatch(showLoader(true));
      await communitiesService.update(c);
      dispatch(showLoader(false));
      dispatch(resetModal());
      setCurrentCommunity(null);
      setReload({});
    } catch (err) {
      dispatch(showLoader(false));
      console.error(err);
    }
  };

  const add = async (c) => {
    try {
      const communitiesService = CommunitiesService();
      dispatch(showLoader(true));
      await communitiesService.post(c);
      dispatch(showLoader(false));
      dispatch(resetModal());
      setCurrentCommunity(null);
      setReload({});
    } catch (err) {
      dispatch(showLoader(false));
      console.error(err);
    }
  };

  const tCommunities = communities?.map((c, indx) => {
    return {
      entity: c,
      name: (
        <React.Fragment>
          <div
            className="d-flex justify-content-sart align-items-center"
            key={indx}
          >
            <img
              className="rounded-circle avatar-sm"
              src={c.image ? c.image : avatar}
              alt={"avatar"}
            />
            <h5 className="mx-2 d-inlone-block">{c.name}</h5>
          </div>
        </React.Fragment>
      ),
      registration_date: c?.createdAt
        ? moment(c.createdAt).calendar(c.createdAt)
        : "",
      members: c?.users && c?.users?.length > 0 ? c?.users?.length : 0,
      community_type: c?.communityType ? c?.communityType : ''
    };
  });

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setCurrentCommunity(row.entity);
    },
  };

  const columns = [
    {
      dataField: "name",
      text: "NAME",
      sort: true,
    },
    {
      dataField: "registration_date",
      text: "REGISTRATION DATE",
      sort: true,
    },
    {
      dataField: "members",
      text: "MEMBERS",
      sort: true,
    },
    {
      dataField: "community_type",
      text: "Community Type",
      sort: true,
    },
  ];

  useEffect(() => {
    const getUsers = async () => {
      try {
        const usersService = UsersService();
        const res = await usersService.getAll();
        if (res && mounted) {
          setUsers(
            res.map((u) => ({
              label: u.firstName + " " + u.lastName,
              value: u._id,
              obj: u,
            }))
          );
        }
      } catch (err) {
        console.error(err);
      }
    };

    // const getPosts = async () => {
    //     try {
    //         const postService = PostService();
    //         const res = await postService.get();
    //         if (res && mounted) {
    //             setPosts(res.map(p => ({ label: p?.content[0]?.title, value: p._id, obj: p })));
    //         }
    //     } catch (err) {

    //     }
    // }

    const getCommunities = async () => {
      try {
        const communitiesService = CommunitiesService();
        const res = await communitiesService.get();
        if (res && mounted) {
          setCommunities(
            res.map((c) => ({
              ...c,
              users: c?.users
                ? c?.users.map((u) => ({
                  label: u.firstName + " " + u.lastName,
                  value: u._id,
                }))
                : [],
            }))
          );
        }
      } catch (err) {
        console.error(err);
      }
    };
    const fetchData = async () => {
      try {
        dispatch(showLoader(true));
        await getCommunities();
        await getUsers();
        // await getPosts();
        dispatch(showLoader(false));
      } catch (err) {
        console.error(err);
        dispatch(showLoader(false));
      }
    };
    fetchData();
    return () => {
      setMounted(false);
    };
  }, [dispatch, setMounted, setCommunities, mounted, setUsers, reload]);

  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="mb-3">
            <Breadcrumbs title="MAIN" breadcrumbItem="Communities" />
          </div>
          <div className="my-3 d-flex justify-content-end">
            <button
              color="success"
              onClick={() => openFormEdit(undefined, add)}
            >
              Add Community +
            </button>
          </div>
          <div className="row justify-content-around">
            <div className="col-12 col-md-7">
              <DatatableTables
                columns={columns}
                data={tCommunities}
                desc={""}
                rowEvents={rowEvents}
              ></DatatableTables>
            </div>
            <div className="col-6 col-md-4">
              <CurrentCommunity
                openFormEdit={openFormEdit}
                users={users}
                // posts={posts}
                currentCommunity={currentCommunity}
                action={update}
                setCurrentCommunity={setCurrentCommunity}
              ></CurrentCommunity>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
